<div class="modal-header">
  <h2 class="modal-title" id="ks-template-field-modal-title">{{ title() }}</h2>

  <button type="button" class="ks-modal-close" aria-label="Cerrar" (click)="cancel()">
    <i class="bi bi-x-lg" aria-hidden="true"></i>
  </button>
</div>

<div class="modal-body">
  <form id="ks-template-field-form" [formGroup]="form" (ngSubmit)="save()" novalidate>
    <div class="ks-form-group">
      <label class="ks-label" for="ks-template-field-type">Tipo de campo</label>

      <!--
        ng-select, no <select>: el catalogo de tipos crece y hay que poder
        BUSCAR. El id del input interno lo pone `labelForId`, asi que el
        `<label for>` de arriba sigue apuntando al elemento que recibe el foco.
        `aria-describedby` senala SIEMPRE al mismo id: la pista y el error son
        excluyentes en la plantilla, asi que solo uno existe a la vez.
      -->
      <ng-select
        labelForId="ks-template-field-type"
        formControlName="fieldType"
        [items]="fieldTypeOptions()"
        bindLabel="label"
        bindValue="fieldType"
        placeholder="Selecciona un tipo"
        notFoundText="Sin resultados"
        clearAllText="Quitar selección"
        loadingText="Cargando tipos de campo…"
        typeToSearchText="Escribe para buscar"
        [searchable]="true"
        [inputAttrs]="fieldTypeInputAttrs()"
        [class.is-invalid]="invalid('fieldType')" />

      @if (invalid('fieldType')) {
        <p class="ks-field-error" id="ks-template-field-type-desc" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Elige el tipo de campo.
        </p>
      } @else {
        <p class="ks-field-hint" id="ks-template-field-type-desc">
          @if (isEdit()) {
            El tipo de campo no se puede cambiar. Bórralo y créalo de nuevo si necesitas otro.
          } @else {
            Solo se listan los tipos de campo activos del catálogo.
          }
        </p>
      }

      @if (selected(); as fieldType) {
        <div class="ks-type-note">
          @if (fieldType.protected) {
            <span class="ks-badge ks-badge--warning">
              <i class="bi bi-shield-lock" aria-hidden="true"></i>
              Protegido
            </span>
          }
          @if (fieldType.multiline) {
            <span class="ks-badge ks-badge--info">
              <i class="bi bi-textarea-resize" aria-hidden="true"></i>
              Multilínea
            </span>
          }
          @if (!fieldType.protected && !fieldType.multiline) {
            <span class="ks-badge ks-badge--muted">Texto simple</span>
          }
        </div>
      }
    </div>

    <div class="ks-form-group">
      <label class="ks-label" for="ks-template-field-label">Etiqueta</label>

      <input
        id="ks-template-field-label"
        type="text"
        class="ks-field"
        formControlName="label"
        autocomplete="off"
        placeholder="Correo electrónico"
        [attr.aria-invalid]="invalid('label') ? 'true' : null"
        [attr.aria-describedby]="invalid('label') ? 'ks-template-field-label-error' : 'ks-template-field-label-hint'" />

      @if (invalid('label')) {
        <p class="ks-field-error" id="ks-template-field-label-error" role="alert">
          <i class="bi bi-exclamation-circle" aria-hidden="true"></i>
          Escribe una etiqueta de máximo 150 caracteres.
        </p>
      } @else {
        <p class="ks-field-hint" id="ks-template-field-label-hint">
          Es el texto que la app muestra encima del campo.
        </p>
      }
    </div>

    <fieldset class="ks-switches">
      <legend class="ks-label">Opciones</legend>

      <label class="ks-switch ks-switch--row" for="ks-template-field-required">
        <input
          id="ks-template-field-required"
          type="checkbox"
          role="switch"
          class="ks-switch__input"
          formControlName="required"
          aria-describedby="ks-template-field-required-hint" />

        <span class="ks-switch__track" aria-hidden="true">
          <span class="ks-switch__thumb"></span>
        </span>

        <span class="ks-switch__text">
          <span class="ks-switch__title">Obligatorio</span>
          <span class="ks-switch__hint" id="ks-template-field-required-hint">
            La app exige un valor antes de guardar.
          </span>
        </span>
      </label>

      <label class="ks-switch ks-switch--row" for="ks-template-field-primary">
        <input
          id="ks-template-field-primary"
          type="checkbox"
          role="switch"
          class="ks-switch__input"
          formControlName="primaryField"
          aria-describedby="ks-template-field-primary-hint" />

        <span class="ks-switch__track" aria-hidden="true">
          <span class="ks-switch__thumb"></span>
        </span>

        <span class="ks-switch__text">
          <span class="ks-switch__title">Campo principal</span>
          <span class="ks-switch__hint" id="ks-template-field-primary-hint">
            @if (protectedTypeSelected()) {
              Los campos protegidos no pueden ser el campo principal.
            } @else {
              Su valor se muestra debajo del nombre de la credencial en la app.
            }
          </span>
        </span>
      </label>

      @if (willReplacePrimaryField()) {
        <p class="ks-primary-replace-note" role="status">
          <i class="bi bi-exclamation-triangle" aria-hidden="true"></i>
          Reemplazará a «{{ existingPrimaryField()!.label }}» como campo principal.
        </p>
      }

      @if (isEdit()) {
        <label class="ks-switch ks-switch--row" for="ks-template-field-status">
          <input
            id="ks-template-field-status"
            type="checkbox"
            role="switch"
            class="ks-switch__input"
            formControlName="status"
            aria-describedby="ks-template-field-status-hint" />

          <span class="ks-switch__track" aria-hidden="true">
            <span class="ks-switch__thumb"></span>
          </span>

          <span class="ks-switch__text">
            <span class="ks-switch__title">Activo</span>
            <span class="ks-switch__hint" id="ks-template-field-status-hint">
              Los campos inactivos dejan de aparecer en la app.
            </span>
          </span>
        </label>
      }
    </fieldset>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="ks-btn ks-btn--glass" (click)="cancel()">Cancelar</button>

  <!-- `form=` deja el submit fuera del <form> sin anidar formularios. -->
  <button type="submit" form="ks-template-field-form" class="ks-btn ks-btn--primary">
    <i class="bi bi-check-lg" aria-hidden="true"></i>
    Guardar campo
  </button>
</div>
